export const DiscountModulesEnum = {
  DAVS: 'davs',
  NFE: 'nfe',
  NFCE_PDV: 'nfcePdv',
};

export const DiscountBasedOnEnum = {
  ITEM: 0,
  DOC: 1,
};
